import DashboardStore from "./Dashboard/DashboardStore";
import AIAgentStore from "./AIAgent/AIAgentStore";
import UserManagementStore from "./UserManagement/UserManagement.Store";

const administrationStoreList = [
    { name: "dashboardStore", store: DashboardStore },
    { name: "aiAgentStore", store: AIAgentStore },
    { name: "userManagementStore", store: UserManagementStore },
];

export default administrationStoreList;
